import {
	DANGER_COLOR,
	DANGER_LIGHT_HOVER_COLOR,
	DISABLED_COLOR,
	MAIN_COLOR,
	MAIN_LIGHT_HOVER_COLOR,
} from 'shared/consts';
import { TColorText } from 'shared/types';
import styled, { css } from 'styled-components';

interface Button {
	$isFullWidth?: boolean;
	$color?: TColorText;
}

const getColor = (type: TColorText = 'default') => {
	switch (type) {
		case 'main':
			return { color: MAIN_COLOR, hoverColor: MAIN_LIGHT_HOVER_COLOR };
		case 'danger':
			return {
				color: DANGER_COLOR,
				hoverColor: DANGER_LIGHT_HOVER_COLOR,
			};
		default:
			return { color: MAIN_COLOR, hoverColor: MAIN_LIGHT_HOVER_COLOR };
	}
};

export const Button = styled.button<Button>`
	color: ${props => getColor(props.$color).color};
	padding: 8px 0;
	border-radius: 48px;
	background-color: transparent;

	${props =>
		props.$isFullWidth &&
		css`
			width: 100%;
		`}

	padding: 8px;
	transition: background-color 0.3s ease, border-color 0.3s ease;

	${props =>
		!props.disabled &&
		css`
			&:hover {
				background-color: ${getColor(props.$color).hoverColor};
			}
		`};

	${props =>
		props.disabled &&
		css`
			background-color: ${DISABLED_COLOR};
			color: #fff;
		`};
`;
